import React from 'react';
import { Layout } from 'react-admin';
import CustomMenu from './CustomMenu';

export const MyLayout = ({ children }) => (
  <Layout menu={CustomMenu}>
    {children}
  </Layout>
);